import { render, staticRenderFns } from "./WisdomShow.vue?vue&type=template&id=4b32260a"
import script from "./WisdomShow.vue?vue&type=script&lang=js"
export * from "./WisdomShow.vue?vue&type=script&lang=js"
import style0 from "./WisdomShow.vue?vue&type=style&index=0&id=4b32260a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports